import React from 'react';
import EventListItem from './EventListItem';

function getDateObj(date) {
  if (!date) return null;
  if (typeof date.toDate === 'function') {
    return date.toDate();
  }
  const d = new Date(date);
  return isNaN(d) ? null : d;
}

function EventList({ events = [], limit, user }) {
  const sortedEvents = [...events].sort((a, b) => {
    const dateA = getDateObj(a.date);
    const dateB = getDateObj(b.date);
    if (!dateA || !dateB) return 0;
    return dateB - dateA;
  });

  const displayedEvents = limit ? sortedEvents.slice(0, limit) : sortedEvents;

  return (
    <div className="event-list">
      {displayedEvents.map(event => (
        <EventListItem 
        key={event.id} 
        event={event} 
        user={user} 
        />
      ))}
    </div>
  );
}

export default EventList;